module.exports = __webpack_public_path__ + "static/media/IMG_0543_Reduced.05cb2071.jpg";